import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withAuthorization } from '../../../shared/services/auth/with-authorization/with-authorization.component';
import {
  resolveRoleDashboard,
  ROLE_DASHBOARD_PERMITTED_ROLES
} from '../../shared/config/role-dashboard.config';
import { AdminDashboard } from './components/admin-dashboard.component';
import { TeamDashboard } from './components/team-dashboard.component';
import { birdToast } from '../../../shared/components/core-ui/toast';

const WELCOME_TOAST_ID = 'role-dashboard-welcome';
const WELCOME_DURATION_MS = 60_000;
const WELCOME_MESSAGE = {
  admin:
    'Welcome to your new dashboard. Business KPIs, bookings, revenue, occupancy and team health now live in one place, so every decision starts from the same up-to-date numbers.',
  team: 'Welcome to your new dashboard. Your goals, leads, tickets and team work now open first, so you start the day knowing what needs you and how close the team is to target.'
};

export const RoleDashboardContainer = () => {
  const dashboard = useMemo(resolveRoleDashboard, []);

  useEffect(() => {
    if (dashboard.kind === 'redirect') return;
    birdToast.info(WELCOME_MESSAGE[dashboard.kind], '', {
      id: WELCOME_TOAST_ID,
      duration: WELCOME_DURATION_MS,
      closable: true
    });
  }, [dashboard.kind]);

  if (dashboard.kind === 'redirect') {
    return <Redirect to={dashboard.path} />;
  }

  return (
    <div className="min-h-[calc(100vh-45px)] w-full bg-white px-[clamp(16px,3vw,48px)] pb-20 pt-8">
      <div className="mx-auto max-w-[1440px]">
        {dashboard.kind === 'admin' ? (
          <AdminDashboard superAdmin={dashboard.superAdmin} />
        ) : (
          <TeamDashboard
            goals={dashboard.goals}
            verticals={dashboard.verticals}
            panels={dashboard.panels}
          />
        )}
      </div>
    </div>
  );
};

export default connect()(
  withAuthorization(ROLE_DASHBOARD_PERMITTED_ROLES, true)(RoleDashboardContainer)
);
